import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';

@Component({
  selector: 'app-show-errors',
  templateUrl: './show-errors.component.html',
  styleUrls: ['./show-errors.component.scss']
})
export class ShowErrorsComponent implements OnInit {
  @Input() errorFormList: ShowErrorModel[];

  public showAll = false;

  constructor() {}

  ngOnInit(): void {}

  clickToogleShowMoreErrors() {
    this.showAll = !this.showAll;
  }
}
